import { useQuery, useQueryClient } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { IglooPin, normalizeIglooPin, RawIglooPin } from './normalize-igloo-pin'

type GetIglooPinRequest = { clientId: string }

export const getIglooPinQueryKey = (data: GetIglooPinRequest) => ['useGetIglooPin', data]

const getIglooPin = async (data: GetIglooPinRequest): Promise<IglooPin> => {
  const response = await authAPI.get<RawIglooPin>(`/igloowork/${data.clientId}/pin`)
  return normalizeIglooPin(response.data)
}

export const useGetIglooPin = (data: GetIglooPinRequest, enabled = true) =>
  useQuery({
    enabled: enabled && Boolean(data.clientId),
    queryFn: () => getIglooPin(data),
    queryKey: getIglooPinQueryKey(data),
  })

export const useInvalidateIglooPin = (clientId: string) => {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries({ queryKey: getIglooPinQueryKey({ clientId }) })
}
